import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../../utils/styles';

const StyledUnmatchedTotals = styled(Space)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledUnmatchedTotalsItem = styled.div`
  ${typographyStyles.body.medium};
  color: ${props => props.color};
  display: flex;
  flex-direction: column;
`;

const StyledUnmatchedTotalsItemMark = styled.span`
  border-radius: 1px;
  background-color: ${props => props.color};
  display: inline-block;
  height: 7px;
  width: 6px;
`;

const StyledUnmatchedTotalsItemValue = styled.span`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_10};
  text-wrap: nowrap;
`;

export {
  StyledUnmatchedTotals,
  StyledUnmatchedTotalsItem,
  StyledUnmatchedTotalsItemMark,
  StyledUnmatchedTotalsItemValue,
};
